"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'www.wp.pl',
    'gwiazdy.wp.pl',
    'wiadomosci.wp.pl',
    'turystyka.wp.pl',
    'teleshow.wp.pl',
    'kobieta.wp.pl',
    'kuchnia.wp.pl',
    'opinie.wp.pl',
    'finanse.wp.pl',
    'gry.wp.pl',
    'film.wp.pl',
    'facet.wp.pl',
    'ksiazki.wp.pl',
    'dom.wp.pl',
    'tech.wp.pl',
    'moto.wp.pl',
    'centralagier.wp.pl',
    'magazyn.wp.pl',
    'money.wp.pl',
    'tv.wp.pl',
    'sportowefakty.wp.pl',
    'wawalove.wp.pl',
    'telewizja.wp.pl',
    'pogoda.wp.pl',
    'pilot.wp.pl',
    'wroclaw.wp.pl',
    'wideo.wp.pl',
    'ads.wp.pl',
];
